<script>
export default {
    data() {
        return {
            row: null
        }
    },
    computed: {
        partyType() {
            if (!this.row) return ''
            return this.row.party_type === 'App\\Models\\Lead' ? 'Lead' : 'Customer'
        },
        partyRoute() {
            if (!this.row) return {}
            return this.row.party_type === 'App\\Models\\Lead'
                ? { name: 'leads-details', params: { id: this.row.party_id } }
                : { name: 'customers-details', params: { id: this.row.party_id } }
        }
    },
    methods: {
        open(row) {
            this.row = row
        }
    }
}
</script>

<template>
    <div class="modal fade" id="inspection_party_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content border-0" style="border-radius:14px;" v-if="row">

                <div class="modal-header border-bottom py-3 px-4">
                    <h5 class="modal-title fw-bold" style="font-size:14px; color:#0f172a;">
                        <i class="ti ti-user me-2" style="color:#6366f1;"></i>
                        Client Details
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>

                <div class="modal-body px-4 py-3">

                    <div class="d-flex align-items-center gap-2 mb-3">
                        <span class="badge bg-light border" style="font-size:11px; color:#475569;">
                            {{ row.inspection_number }}
                        </span>

                    </div>

                    <table class="table table-borderless mb-0" style="font-size:12.5px;">
                        <tbody>
                            <tr>
                                <td style="color:#94a3b8; width:100px; padding:6px 0;">Name</td>
                                <td style="color:#0f172a; font-weight:600; padding:6px 0;">{{ row.party?.name || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">Mobile</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.mobile || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">Email</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.email || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">Address</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.address || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">City</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.city || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">State</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.state || '-' }}</td>
                            </tr>
                            <tr>
                                <td style="color:#94a3b8; padding:6px 0;">Pincode</td>
                                <td style="color:#0f172a; padding:6px 0;">{{ row.party?.pincode || '-' }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>

            </div>
        </div>
    </div>
</template>